import {
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  REFRESH_STATE,
  RESET_FORGET_PASSWORD_USER_EMAIL,
  RESET_FORGET_PASSWORD_USER_OTP,
  RESET_IS_SIGNING,
  SET_FORGET_PASSWORD_USER_EMAIL,
  SET_FORGET_PASSWORD_USER_OTP,
  SET_IS_SIGNING,
  SET_LOGGEDIN_USER,
  SET_LOGGEDOUT_USER,
  SELECTED_USER,
  SET_IS_SUBMITING,
  RESET_IS_SUBMITING,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_TOTAL_USERS_SUCCESS,
  FETCH_TOTAL_USERS_FAILURE,
} from "./type.js";

const initialState = {
  loggedInUser: null,
  token: null,
  isLoading: false,
  error: "",
  isSigning: false,
  isSubmiting: false,
  users: [],
  forgetEmail: "",
  otp: null,
  selecteduser: null,
  totalPage: 0,
  totalUsers: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: action.payload.users,
        selecteduser: null,
        totalPage: action.payload.totalpage,
        error: "",
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        users: [],
        selecteduser: null,
        error: action.payload,
      };
    case FETCH_TOTAL_USERS_SUCCESS:
      return {
        ...state,
        totalUsers: action.payload.totalusers,
        error: "",
      };
    case FETCH_TOTAL_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_USER_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selecteduser: action.payload,
        error: "",
      };
    case FETCH_USER_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case SET_LOGGEDIN_USER:
      return {
        ...state,
        loggedInUser: action.payload.user,
        token: action.payload.token,
        error: "",
        isSigning: false,
        forgetEmail: "",
        otp: null,
      };
    case SET_LOGGEDOUT_USER:
      return {
        ...state,
        ...initialState,
      };
    case SET_FORGET_PASSWORD_USER_EMAIL:
      return {
        ...state,
        forgetEmail: action.payload,
      };
    case RESET_FORGET_PASSWORD_USER_EMAIL:
      return {
        ...state,
        forgetEmail: "",
      };
    case SET_FORGET_PASSWORD_USER_OTP:
      return {
        ...state,
        otp: action.payload,
      };
    case RESET_FORGET_PASSWORD_USER_OTP:
      return {
        ...state,
        otp: "",
      };
    case SET_IS_SIGNING:
      return {
        ...state,
        isSigning: true,
      };
    case RESET_IS_SIGNING:
      return {
        ...state,
        isSigning: false,
      };
    case SET_IS_SUBMITING:
      return {
        ...state,
        isSubmiting: true,
      };
    case RESET_IS_SUBMITING:
      return {
        ...state,
        isSubmiting: false,
      };
    case REFRESH_STATE:
      return {
        ...state,
        token: action.payload.token,
        loggedInUser: action.payload.user,
      };
    case SELECTED_USER:
      return {
        ...state,
        selecteduser: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
